export default __webpack_public_path__ + "static/media/neetchallenger_icon.6563fbb7.svg";